module.exports = __webpack_public_path__ + "img/17_21.68fc46a6.png";